import React, { FC } from "react";

type PropsType = {
  title: string;
};

export const SidebarSectionHeader: FC<PropsType> = ({ title }: PropsType) => (
  <div className="px-4 pt-5">
    <span className="text-sm font-bold tracking-widest text-secondary-600">
      {title}
    </span>
  </div>
);
